export const JOBS_ADD = 'JOBS_ADD'
export const JOBS_REMOVE = 'JOBS_REMOVE'
export const JOBS_EMPTY = 'JOBS_EMPTY'